import settings from "../../settings";

export const TRANSLATION_IT = {
    common: {
        reset: 'Reset',
        vlmAcronym: 'VLM',
        vlmLabel: '(Vendor Lifecycle Management)',
        loading: 'Caricamento...',
        accept: "Accetta",
        success: "Successo",
        buttonActions: {
            services: {
                addServices: 'Aggiungi servizi'
            },
            fleet: {
                modifyFleet: 'Modifica flotta'
            },
            routes: {
                addRoutes: 'Aggiungi rotte'
            },
            driver: {
                addDriver: 'Aggiungi autista'
            },
            addVehicle: "Aggiungi Veicolo",

        },
        menu: {
            dashboard: 'Dashboard',
            services: 'Servizi',
            documents: 'Documenti',
            contracts: 'Contratti',
            trips: 'Viaggi',
            fleetAndRoute: 'Flotta e Rotte',
            settings: 'Impostazioni',
            app: "Vai all'App"
        },
        errors: {
            engineTypePercent: 'Il tipo di motore deve essere di somma 100.',
            emissionClassPercent: 'La classe di emissione deve essere di somma 100.',
            addingRoutes: 'C\'è stato un errore aggiungendo le rotte.',
            zeroVehicles: "Devi inserire almeno un veicolo",
            mandatoryField: "Campo obbligatorio"
        },
        sidebars: {
            addDriver: {
                heading: 'Aggiungi Autista',
                paragraph: 'Dati Generali',
                name: 'Nome',
                addName: 'Inserisci Nome',
                surname: 'Cognome',
                addSurname: 'Inserisci Cognome',
                phone: 'Telefono',
                addPhone: 'Inserisci Telefono',
                pIva: 'P.IVA',
                addPIva: 'Inserisci P.IVA',
                email: 'Email',
                addEmail: 'Inserisci Email',
                info: 'I campi sono obbligatori',
                button: 'Aggiungi Autista',
                driverStatus: 'Stato Autista',
                invalidEmail: "Inserisci un'email valida",
                add: 'Aggiungi'
            },
            saveButtonText: "Salva",
            addServices: {
                heading: 'Aggiungi servizi',
                button: 'Aggiungi servizi',
                goBack: 'Indietro'
            },

            modifyFleet: {
                heading: 'Modifica flotta',
                subParts: {
                    typeOfEngine: {
                        heading: 'Tipo di motore',
                        paragraph: 'Hai un totale di <strong>{{count_vehicles}}</strong> veicoli. Per favore, indica una percentuale per il tipo di motore della tua flotta:'
                    },
                    emissionClass: {
                        heading: 'Classe di emissione',
                        paragraph: 'In base al tipo di motore indicare la classe di emissione.'
                    }
                }
            },
            addRoutes: {
                heading: 'Aggiungi rotte',
                stepOne: {
                    heading: 'Seleziona da',
                    paragraph: 'Scegli un paese facendo clic sulla mappa. Puoi anche iniziare a digitare nel campo di immissione e selezionare dal menu.',
                    selectLabel: 'Da',
                    selectPlaceholder: 'Inserisci nazione',
                    button: 'Procedi allo step 2'
                },
                stepTwo: {
                    heading: 'Seleziona a',
                    paragraph: 'Scegli i paesi cliccando sulla mappa. Puoi anche aggiungere paesi digitando nel campo di inserimento. Definire se sola andata o andata e ritorno per ogni percorso.',
                    selectToLabel: 'A',
                    selectToPlaceholder: 'Inserisci nazione',
                    selectTypeLabel: 'Tipologia',
                    selectTypePlaceholder: 'Inserisci tipologia',
                    button: 'Conferma rotte'
                },
            },

            addVehicle: {
                heading: 'Aggiungi veicolo',
                button: 'Aggiungi veicolo',
                paragraph: 'Dati generali',
                vehiclePlate: "Targa veicolo",
                addVehiclePlate: 'Inserisci targa',
                addPlate: 'Aggiungi targa',
                fleetType: "Categoria mezzo",
                addFleetType: 'Inserisci categoria mezzo',
                categoryType: "Tipologia mezzo",
                addCategoryType: 'Inserisci tipologia mezzo',
                registrationDate: "Prima Immatricolazione",
                addRegistrationDate: 'Inserisci data di registrazione',
                vehicleDocument: "Libretto di circolazione",
                addVehicleDocument: 'Carica documento',
                environmentalClassEuro: "Classe di emissioni",
                selectEnvironmentalClassEuro: 'Seleziona classe ambientale Euro',
                fuelType: "Tipo di  motore",
                addFuelType: 'Inserisci tipo di  motore',
                emissionData: "Dati di emissione",
                addEmissionData: 'Inserisci dati di emissione',
                vectoDeclaration: "Dichiarazione VECTO",
                addVectoDeclaration: 'Inserisci dichiarazione VECTO',
                info: '*Campi obbligatori',
                sustainabilityData: 'Dati Sostenibilità',
                vehicleStatus: 'Stato Veicolo',
                remove: 'Rimuovi',
                selectData: 'Seleziona Data',
                add: 'Aggiungi',
                loadCapacity: "Capacità Carico",
                loadCapacityUDM: "UDM Capacità Carico",
                modify: 'Modifica',
                mandatoryField: 'Campi Obbligatori',
                saveChanges: "Salva Modifiche",
                vehicle: 'Mezzo',
                untrackablePlateWithTrips: "Targa {{licensePlate}} associata ai viaggi:",
                untrackablePlate: "Targa {{licensePlate}} verificata come non tracciabile sulla piattaforma {{platform}}",
                isReportedAsUntrackable: "verificata come non tracciabile sulla piattaforma {{platform}}",
                unassociatedPlate: "Targa non associata ad alcun conducente. Per i servizi di trazione, associa la targa a un conducente o seleziona un'altra targa"
            },
            addAssociations: {
                plate: "Targa",
                vehicle: 'Tipo Veicolo',
                startDate: 'Data inizio',
                endDate: 'Data fine',
                insertPlate: 'Inserisci Targa',
                newAssociation: 'Nuova Associazione',
                addNew: 'Aggiungi nuova associazione',
                save: 'Salva',
                cancel: 'Annulla',
                vehicleAssociation: 'Stato Associazione',
                modifyAssociation: 'Modifica Associazione',
                dateOverlapError: "L'ultima data inserita presenta conflitti "


            },
            addDocument: {
                heading: 'Aggiungi Documento',
                dragNDropText: 'Trascina e rilascia o clicca per caricare',
                document: 'Documento'
            },
            addContractDocument: {
                heading: "Carica documento",
                loading: 'Caricamento...',
                submit: "Invia documento",
                document: "Documento",
                dragNDropText: "Trascina e rilascia qui il tuo documento o fai clic per scegliere un documento dal tuo dispositivo."
            },
            addUser: {
                heading: "Aggiungi utente",
                name: "Nome",
                surname: "Cognome",
                email: "Email",
                confirmEmail: "Conferma email",
                phone: "Telefono",
                role: "Ruolo"
            },
            modifyUser: {
                heading: "Modifica utente",
                name: "Nome",
                surname: "Cognome",
                email: "Email",
                confirmEmail: "Conferma email",
                phone: "Telefono",
                role: "Ruolo"
            },
            notifications: {
                heading: "Notifiche",
                seeAllNotifications: "Vedi tutte le notifiche lette",
                emptyNotificationsToRead: "Non ci sono notifiche da leggere.",
                emptyNotifications: "Non ci sono notifiche lette da mostrare."
            }
        }
    },
    screens: {
        dashboard: {
            welcomeGreeting: 'Ciao',
            subHeading: 'Questo è il tuo stato',
            widgets: {
                services: {
                    heading: 'I miei servizi',
                    status: 'Status',
                    additionalServices: 'Servizi aggiuntivi',
                    additionalServiceSingular: 'Servizio aggiuntivo',
                    link: 'Vai ai servizi'
                },
                fleet: {
                    heading: 'La mia flotta',
                    engineType: 'Tipo di motore',
                    emissionClass: 'Classe di emissione',
                    link: 'Vai alla flotta'
                },
                registeredFleet: {
                    heading: 'La mia flotta',
                    engineType: 'Tipo di motore registrato',
                    emissionClass: 'Classe di emissione registrata',
                    link: 'Vai alla flotta',
                    vehicles: 'Veicoli',
                    trailers: 'Semirimorchi'
                },
                documents: {
                    heading: 'I miei documenti',
                    button: 'Controlla',
                    link: 'Vai ai documenti',
                    documentPrefixes: {
                        plural: 'documenti',
                        singular: 'documento'
                    }
                },
                routes: {
                    heading: 'Le mie rotte',
                    link: 'Vai alle rotte'
                },
                contracts: {
                    heading: 'I miei contratti',
                    otherContract: "contratto attivo",
                    otherContracts: "contratti attivi",
                    toBeAcceptedContract: "contratto da accettare",
                    toBeAcceptedContracts: "contratti da accettare",
                    link: 'Vai ai contratti',
                    bankDataMissing: "Inserisci i tuoi dati bancari per abilitare i pagamenti delle tue fatture"
                },
                trips: {
                    heading: 'I miei viaggi',
                    button: "Controlla",
                    link: 'Vai ai viaggi',
                    tripPrefixes: {
                        singular: 'Viaggio',
                        plural: 'Viaggi'
                    },
                    kpi: {
                        1: "senza targa",
                        2: "non approvati",
                        3: "con documentazione non completata",
                    }
                }
            }
        },
        services: {
            heading: 'Servizi',
            tabMainServices: 'Servizi principali',
            tabAdditionalServices: 'Servizi aggiuntivi',
            emptyServices: 'Non ci sono servizi da mostrare.',
            filter: 'Filtra',
            allServices: 'Tutti i servizi',
            tableHeaders: {
                category: 'Categoria',
                serviceType: 'Tipo di servizio',
                info: 'Informazioni',
                status: 'Status'

            }
        },
        documents: {
            heading: 'Documenti',
            emptyDocuments: 'Non ci sono documenti da mostrare.',
            filter: 'Filtra',
            allDocuments: 'Tutti i documenti',
            nDocuments: '{{value}} documenti',
            downloadTemplate: 'scarica documento',
            validUntil: 'Valido fino al ',
            uploaded: 'Ultimo caricamento',
            note: 'Note',
            uploadRequested: 'Caricamento obbligatorio',
            uploadNotMandatory: "Caricamento opzionale",
            acceptanceRequest: 'Richiesta di accettazione',
            updateRequested: 'Aggiornamento richiesto',
            uploadTemplate: 'Carica template',
            uploadNewVersion: 'Carica nuova versione',
            uploadTemplateText: "Devi scaricare e compilare il modello. Quindi proceduto a caricare il documento nel formato richiesto.",
            updateRequestedText: "Hai <strong>{{days_before_blocking}}</strong> giorni per caricare una versione aggiornata del documento prima che il servizio venga disattivato.",
            uploadRequestedText: "Il documento è necessario per l'attivazione dei servizi.",
            uploadMultipleRequestedText: "Uno o più documenti sono richiesti per l'attivazione del servizio",
            tableHeaders: {
                category: 'Categoria',
                type: 'Tipologia',
                subType: 'Sotto Tipologia',
                uploaded: 'Caricato',
                validUntil: 'Valido fino al ',
                status: 'Status',
                action: 'Azione',
                note: 'Note',
                name: "Nome documento"
            }
        },
        contracts: {
            heading: 'Contratti',
            emptyContracts: 'Non ci sono contratti da mostrare.',
            iban: 'Iban',
            swift: "Swift",
            paymentTerms: 'Termini di pagamento',
            filter: 'Filtra',
            allContracts: 'Tutti i contratti',
            validUntil: 'Valido fino al ',
            signed: 'Firmato il',
            signRequested: 'Firma richiesta',
            signRequestedText: 'Il contratto deve essere firmato. Controlla la tua posta per le istruzioni.',
            actionRequired: 'Azione richiesta',
            acceptanceRequested: 'Accettazione richiesta',
            acceptanceRequestedText: "Fare clic sul collegamento del documento per accettare la visualizzazione.",
            insertBankData: "Inserisci dati bancari",
            tableHeaders: {
                contract: 'Contratto',
                legalRepresentative: 'Rappresentante legale',
                paymentTerms: 'Termini di pagamento',
                signed: 'Firmato il',
                validUntil: 'Valido fino al ',
                status: 'Status',
                note: 'Note'
            },
            isUnderEvaluation: "In valutazione",
        },
        trips: {
            heading: 'Viaggi',
            showMore: 'Mostra altro',
            showMoreTrips: 'Mostra altri viaggi',
            noLicense: 'Nessuna targa',
            filters: {
                filters: 'Filtri',
                status: 'Stato',
                approval: 'Approvazioni',
                date: 'Data',
                dateRange: 'Intervallo Date',
                filter: 'Filtra'
            },
            columnDef: {
                status: 'Stato',
                approval: 'Approvazione',
                loadDate: 'Data Carico',
                unloadDate: 'Data Scarico',
                expectedDeparture: 'Partenza Prevista',
                expectedArrival: 'Arrivo Previsto',
                tractorLicensePlate: 'Targa Trattore',
                trailerLicensePlate: 'Targa Rimorchio',
                loadingLocation: 'Località Carico',
                unloadingLocation: 'Località Scarico',
                documents: 'Documenti',
                trip: "Disposizione",
                creationMilestone: 'Milestone Creazione'
            },
            tripDialog: {
                tripApproval: 'Approvazione Viaggio',
                tripRejection: "Rifiuto Viaggio",
                approve: 'approvare',
                reject: 'rifiutare',
                approveTrip: 'Approva Viaggio',
                rejectTrip: 'Rifiuta Viaggio',
                doYouWantTo: 'Vuoi',
                thisTrip: 'questo viaggio ?',
                confirmSaveChanges: 'Salvare i cambiamenti ?',
                saveOrDiscardChanges: 'Vuoi salvare il valore aggiornato o annullare le modifiche ?',
                save: 'Salva',
                cancel: 'Annulla',
                reject2: 'rifiuta',
                approve2: 'approva'
            },
            chips: {
                planner: 'PIANIFICATORE',
                firstDriver: 'PRIMO AUTISTA',
                tpSpecialist: 'SPECIALISTA TP',
                email: 'EMAIL',
                phone: 'TELEFONO'
            },
            oriDest: {
                origin: 'ORIGINE',
                destination: 'DESTINAZIONE',
                downloadTransportDocument: 'SCARICA ORDINE DI TRASPORTO'
            },
            loadCard: {
                weight: 'PESO',
                volume: 'VOLUME',
                shipUnitCount: "UNITA' DI CARICO",
                linearMeters: 'METRI LINEARI',
                load: 'CARICO'
            },
            datesCard: {
                dates: 'DATE',
                departure: 'PARTENZA',
                arrival: 'ARRIVO',
                expectedDeparture: 'PARTENZA PREVISTA',
                expectedArrival: 'ARRIVO PREVISTO',
                actualDeparture: 'PARTENZA ATTUALE',
                actualArrival: 'ARRIVO ATTUALE',
                assignedDate: 'DATA ASSEGNATA'
            },
            documentsCard: {
                allTransportDocuments: 'DOCUMENTI DI TRASPORTO',
                checkAllDocuments: 'CONTROLLA TUTTI I DOCUMENTI',
                generalConditions: 'CONDIZIONI GENERALI'
            },
            notesCard: {
                notes: 'NOTE',
                allNotes: 'TUTTE LE NOTE',
                noNotes: 'Nessuna nota',
                note: 'Nota',
                noNotesAvailable: 'Nessuna nota disponibile',
                note1: 'NOTA 1',
                note2: 'NOTA 2'
            },
            licensePlate: {
                saveChanges: "Conferma Modifiche",
                saveOrDiscard: 'Vuoi confermare o annullare le modifiche ?',
                cancel: 'Annulla',
                save: 'Conferma',
                error: 'Errore durante la modifica',
                editCanceled: 'modifica annullata',
                success: 'Targa aggiornata correttamente'
            },
            timeline: {
                from: 'DA',
                to: 'A',
                mandatory: 'TASSATIVO',
                noStops: 'Nessuna tappa disponibile',
                loadingPoint: 'Punto di Carico',
                addPod: 'Aggiungi POD / CMR',
                selectLoadingPoint: 'Seleziona punto di carico',
                selectLoadingPointFirst: 'Seleziona prima un punto di carico',
                documentAlreadyExists: 'Documento già presente per questo punto di carico',
                noLoadingPoints: 'Nessun punto di carico disponibile'
            },
            mobileCard: {
                tripMap: 'MAPPA VIAGGIO',
                tripTimeline: "TIMELINE VIAGGIO"
            },
            tripDocuments: {
                back: "Torna ai dettagli",
                addDocument: "Aggiungi Documento",
                uploaded: "Caricato il ",
                by: "da",
                description: 'Descrizione',
                document: "Documento",
                documents: "Documenti",
                additionalAttachments: "Documenti Aggiuntivi",
                generalConditions: 'Condizioni Generali',
                podMandatoryUpload: "CARICAMENTO POD OBBLIGATORIO",
                documentRejected: 'DOCUMENTO RIFIUTATO',
                insertDocumentError: 'Targa già censita o dati incorretti',
                updateDocumentError: 'Errore durante l\'aggiornamento del veicolo'
            },
            tripDocumentPage: {
                trip: "DISPOSIZIONE"
            },
            approval: {
                on: 'il ',
                by: 'da '
            },
            statusOptions: {
                ASSIGNED: "Assegnato",
                ALLOCATED: "Allocato",
                IN_PROGRESS: "In corso",
                WAITING_FOR_DOCUMENTATION: "In attesa di documentazione",
                COMPLETED: "Completato"
            },
            approvalStatus: {
                APPROVED: "Approvato",
                REJECTED: "Rifiutato",
                TO_APPROVE: "Da approvare",
                AUTO_ACCEPTED: "Accettato automaticamente",
                TO_BE_EVALUATED: 'In attesa di validazione',
                TO_BE_UPLOADED: 'Da caricare',
                ACCEPTED: 'Accettato'
            },
            approvalStatusDoc: {
                APPROVED: "Approvato",
                REJECTED: "Rigettato",
                TO_APPROVE: "Da approvare",
                AUTO_ACCEPTED: "Accettato automaticamente",
                TO_BE_EVALUATED: 'In attesa di valutazione',
                TO_BE_UPLOADED: 'In attesa di caricamento',
                ACCEPTED: 'Validato'
            },
            position: {
                notAvailable: 'Posizione non disponibile'
            },
            agGrid: {
                pageSize: 'Dimensione Pagina',
                page: "Pagina",
                nextPage: "Pagina successiva",
                previousPage: "Pagina precedente",
                lastPage: "Ultima pagina",
                firstPage: "Prima pagina",
                ariaPaginationPage: "Pagina",
                ariaPagination: "Paginazione",
                ariaLabelPagination: "Navigazione tra le pagine",
                rangeSelectionEmpty: "Nessun dato disponibile",
                paginationSummary: "Mostrando {firstRow}-{lastRow} di {rowCount}",
                empty: "Vuoto",
                loadingOoo: "Caricamento in corso...",
                to: 'a',
                of: 'di'
            },
            mapLegend: {
                Legend: "Legenda",
                actualPosition: "Posizione Attuale",
            }
        },
        fleetAndRoute: {
            handleConfirm: {
                title: "Conferma Cambio Stato",
                text: " Sei sicuro di voler cambiare lo stato dell'autista ?",
                text1: " Sei sicuro di voler cambiare lo stato del veicolo con targa",
                text2: "Sei sicuro di voler cambiare lo stato",
                text3: "della relazione autista-mezzo",
                text4: "dell'autista"
            },
            status: {
                "ACTIVE": "ATTIVO",
                "CANCELLED": "INATTIVO"
            },
            statusOnboarding: {
                verified: "Verificato",
                ongoing: "In Corso",
                request: "Richiedi"
            },

            gridAssets: {
                plate: "Targa",
                vehicle: 'Tipo Veicolo',
                firstRegistrationYear: 'Prima Immatricolazione',
                enviromentClass: 'Classe di emissione',
                fuelType: 'Tipo Motore',
                emissionsData: 'Dati Emissioni',
                status: 'Stato Veicolo',
                lastTraceabilityCheck: 'Ultimo controllo Tracciabilità'
            },
            gridGroupedVehicles: {
                plate: "Targa",
                registrationDate: 'Prima Immatricolazione',
                vehicleStatus: 'Stato Veicolo',
                lastTraceabilityCheck: 'Ultimo controllo Tracciabilità'
            },
            gridDrivers: {
                driver: 'Autista',
                phone: 'Cellulare',
                email: 'Email',
                plate: 'targa',
                vehicleType: 'Tipo Veicolo',
                associationPeriod: 'Periodo Associazione',
                status: 'Stato Associazione',
                lastLogin: 'ultimo Accesso App',
                appOnboardingRequest: 'Stato Onboarding App',
                perform: 'Verifica Onboarding',
                onboardingStatus: 'Richiesta Onboarding App',
                lastAssociationUpdate: 'Ultimo aggiornamento associazione',
                driverStatus: 'Stato Autista'
            },
            headerDriver: {
                driver: 'Autista',
                generalData: "Dati Generali",
                name: "Nome",
                surname: "Cognome",
                lastLogin: "Ultimo Accesso App",
                phone: "Telefono",
                email: "Email",
                driverStatus: "Stato Autista",
                lastUpdate: "Ultimo Aggiornamento",
                onboarding: "Onboarding",
                appOnboardingCheck: "Verifica Onboarding App",
                checkOnboarding: "Verifica Onboarding",
                requestOnboarding: "Richiedi Onboarding",
                editDriver: "Modifica Autista",
                addAssociation: "Aggiungi Associazione",
                onGoing: 'In Corso',
                request: 'Richiedi',
                save: 'Salva',
                cancel: 'Annulla',
                ftl: 'FTL',
                partitaIva: 'Codice Trasportatore per App Mobile'

            },
            "vehicles": {
                "3.5 ton van": "Furgone 3.5t",
                "Up to 7.5 ton truck": "Motrice fino a 7.5t",
                "Over 7.5 ton truck": "Motrice oltre 7.5t",
                "Mega tautliner": "Centinato Mega",
                "Standard tautliner": "Centinato Standard",
                "Frigo": "Frigorifero",
                "Coil trailer": "Porta Coil",
                "Standard Truck": "Trattore Standard",
                "Box": "Furgonato",
                "Three axles truck": "Trattore 3 assi",
                "Mega Truck": "Trattore Mega",
                "Container trailer": "Porta-container",
                "Vehicle": "Veicolo",
                "Trailer": "Semirimorchio",
                "INCOMPLETE": "Incompleto"
            },
            fuelType: {
                "CNG": "CNG",
                "Diesel": "Diesel",
                "Electric": "Elettrico",
                "Hybrid": "Ibrido",
                "LNG": "LNG"
            },

            heading: "Flotta e Rotte",
            filter: 'Filtra',
            fleet: 'Flotta',
            registeredAssets: 'Miei veicoli',
            drivers: 'Autisti',
            routes: 'Rotte',
            allVehicles: 'Tutti i veicoli',
            emptyVehicles: 'Non ci sono veicoli da mostrare.',
            tableHeaders: {
                category: 'Categoria',
                type: 'Tipologia',
                number: 'Numero'
            },
            tableHeadersRoutes: {
                from: 'Da',
                to: 'a',
                type: 'Tipologia',
                added: 'Aggiunto il',
                action: 'Azione'
            },
            from: 'Da',
            to: 'a',
            roundtrip: 'Andata e ritorno',
            oneWay: 'Solo andata',
            deleteRoute: 'Cancella rotte',
            loading: 'Caricamento...',
            modalDelete: {
                choseText: "Quali rotte vuoi cancellare?",
                text: "<strong>Da {{country_from_name}} a {{country_to_name}}</strong>.",
                textSingleRoute: "Stai cancellando la rotta <strong>da {{country_from_name}} a {{country_to_name}}</strong>.",
                confirmText: "Vuoi procedere?"
            },
            added: 'Aggiunta',
            emptyRoutes: "Non ci sono rotte da mostrare.",
            toast: {
                associationStatusChanged: "Stato dell'associazione modificato con successo",
                associationStatusChangeError: "Errore durante la modifica dello stato dell'associazione",
                driverStatusChanged: "Stato dell'autista modificato con successo",
                driverStatusChangeError: "Errore durante la modifica dello stato dell'autista"
            },
            errorDialog: {
                driverRemoval: "La disattivazione del driver {{name}}  non è possibile perché è coinvolto nei seguenti viaggi:",
                vehicleRemoval: "La disattivazione del veicolo {{plate}} non è possibile perché è coinvolto nei seguenti viaggi:",
                noteTitle: "Nota da Arcese"
            },
        },
        settings: {
            heading: "Impostazioni",
            email: "Email",
            phone: "Telefono",
            role: "Ruolo",
            properties: "Proprietà",
            accountAdministrator: "Amministratore account",
            emptyContacts: "Non ci sono contatti da mostrare.",
            tableHeaders: {
                user: "Utente",
                email: "Email",
                phone: "Telefono",
                role: "Ruolo",
                properties: "Proprietà"
            },
            modalDeleteUser: {
                deleteUser: "Cancella utente",
                text: "Stai cancellando <strong>{{name}} {{surname}}</strong>. Questa azione non è reversibile.",
                confirmText: "Vuoi procedere?"
            },
            modalChangeAdmin: {
                changeAdmin: "Cambio Amministratore Account",
                text: "Stai facendo <strong>{{name}} {{surname}}</strong> Amministratore dell'account. Perderai il tuo ruolo di amministratore.",
                confirmText: "Vuoi procedere?",
                button: "Cambia amministratore"
            }
        },
        profile: {
            heading: "Profilo",
            userProfile: "Profilo utente",
            businessProfile: "Profilo business",
            email: "Email",
            phone: "Telefono",
            role: "Ruolo",
            building: "Filiale/sede",
            address: "Indirizzo",
            vat: "Partita IVA",
            taxcode: "Codice Fiscale Generico",
            city: "Città",
            zipCode: "Codice Postale",
            status: "Status",
            businessName: "Ragione sociale",
            pec: "PEC",
            marketingCheckboxLabel: "Autorizzo al trattamento dei miei dati per finalità di marketing",
            privacyCheckboxLabel: `Dichiaro di aver letto e di accettare <a href='${settings.privacyUrlIT}' style='text-decoration: underline; color: #cf0a2c' target='_blank'>l'informativa sulla Privacy</a>`,
            collaborationCheckboxLabel: "Acconsento a ricevere comunicazioni per future partnership relative a nuove rotte e servizi",
            variationEffectiveDate: 'Data efficacia variazione',
            deteFormat: 'gg/mm/aaaa',
            selfacceptance: "Autoaccettazione"
        }
    },
    components: {
        modalPdfDocuments: {
            loading: 'Caricamento...',
            errorLoadDocument: 'Si è verificato un errore durante il caricamento del documento.',
            confirmButton: 'Conferma',
            viewFileFullPage: 'Vedi il file a pagina intera',
            previewNotDocx: "Anteprima non disponibile per file .docx",
            download: "Scarica il file",
        },
        modalPdfContracts: {
            loading: 'Caricamento...',
            errorLoadContract: 'Si è verificato un errore durante il caricamento del contratto.',
            confirmButton: 'Conferma',
            viewFileFullPage: 'Vedi il file a pagina intera',
            previewNotDocx: "Anteprima non disponibile per file .docx",
            download: "Scarica il file",
            closeButton: "Chiudi"
        },
        applicationError: {
            text: 'Si è verificato un errore durante il caricamento dell\'applicazione.',
            reload: 'Ricarica'
        },
        accountBlocked: {
            text: "Il suo account è stato bloccato e non può accedere all'applicazione. Si prega di contattare il supporto Arcese per maggiori informazioni."
        },
        authorizationError: {
            text: 'Si è verificato un errore durante l\'autenticazione dell\'utente.',
            reload: 'Riprova autenticazione'
        },
        fleetGraphs: {
            noStats: "Le statistiche sulla tua flotta non sono disponibili."
        },
        profileDropDown: {
            profile: "Profilo",
            logout: "Logout"
        },
        modalGeneralTerms: {
            viewFileFullPage: 'Vedi il file a pagina intera',
            checkboxLabel: "Ho preso visione del documento e ne accetto le condizioni",
            nameGeneralTerms: "Termini generali",
            nameDriversRules: "DUVRI"
        }
    },
    errors: {
        genericErrorRequired: "Il campo {{label}} è richiesto.",
        errorAcceptanceGeneralTerms: "Si è verificato un errore durante l'accettazione.",
        errorModalPdfCheckbox: "Devi spuntare la checkbox di conferma per procedere.",
        errorUploadingDocument: "Errore durante il caricamento del documento.",
        errorElaboratingDocument: "Errore durante l'elaborazione del documento.",
        notSupportedDocument: "Tipo di documento non supportato.",
        errorAddingServices: "Errore durante l'aggiunta di servizi.",
        errorAddingContact: "Errore durante l'aggiunta del contatto.",
        errorModifyingContact: "Error modifying contact.",
        errorCheckingAccountStatus: "Errore nel controllo dello stato dell'account.",
        errorCheckingGeneralTerms: "Errore durante il controllo dei termini e delle condizioni generali.",
        errorAcceptingAddendum: "Si è verificato un errore durante l'accettazione dell'addendum.",
        errorUpdatingIbanSwift: "Errore durante l'aggiornamento dell'iban e/o dello swift. I valori immessi non soddisfano il formato previsto.",
        errorUpdatingSwift: "La lunghezza dello swift deve essere compresa tra 8 e 11 caratteri.",
        errorModifyingProfile: "Errore durante la modifica del profilo.",
        errorModifyingBusinessProfile: "Errore durante la modifica del profilo dell'attività.",
        errorDeletingContact: "Errore durante l'eliminazione del contatto.",
        requiredCity: "La città è richiesta",
        requiredAddress: "L'indirizzo è richiesto",
        requiredBusinessName: "Il nome dell'azienda è richiesto",
        requiredVat: "La P.IVA è richiesta",
        requiredGenericTaxCode: "Codice Fiscale Generico è richiesto",
        requiredZipCode: "Il Codice Postale è richiesto",
        requiredName: "Il nome è richiesto",
        requiredSurname: "Il cognome è richiesto",
        requiredEmail: "La email è richiesta",
        requiredPhone: "Il telefono è richiesto",
        incorrectFormatPhone: "Il formato del telefono non è corretto",
        requiredRole: "Il ruolo è richiesto",
        incorrectFormatEmail: "Il formato dell'email non è corretto",
        requiredConfirmEmail: "La email di conferma è richiesta",
        incorrectFormatConfirmEmail: "Il formato della email di conferma non è corretto",
        confirmEmailMustBeEqualToEmail: "La email di conferma deve essere uguale alla email",
        errorReadNotification: "C'è stato un errore nella lettura della notifica.",
        errorGetNotifications: "C'è stato un errore nella ricezione delle notifiche.",
        requiredDocument: "Il documento è richiesto.",
        errorDownloadTemplate: "Si è verificato un errore durante il recupero del modello.",
        fileValidation: {
            unsupportedFormat: "Formato file non supportato. Formati accettati: {{formats}}",
            fileTooLarge: "File troppo grande. Dimensione massima consentita: {{maxSize}}",
            invalidFile: "File non valido"
        }
    }
}